var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrotherliness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.212 40.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(-2603.288 165.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M34.606,29.314a18.876,18.876,0,1,1,0-20.876,18.876,18.876,0,1,1,0,20.876Z",
    transform: "translate(2604.788 -163.668)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M12,21a10.192,10.192,0,0,0,7.55,3.775A10.192,10.192,0,0,0,27.1,21",
    transform: "translate(2604.114 -162.017)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M13.5,13.5h.019",
    transform: "translate(2604.501 -163.955)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M22.5,13.5h.019",
    transform: "translate(2606.827 -163.955)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10-2",
    "data-name": "Path 10",
    d: "M12,21a10.192,10.192,0,0,0,7.55,3.775A10.192,10.192,0,0,0,27.1,21",
    transform: "translate(2635.574 -162.017)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11-2",
    "data-name": "Path 11",
    d: "M13.5,13.5h.019",
    transform: "translate(2635.961 -163.955)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12-2",
    "data-name": "Path 12",
    d: "M22.5,13.5h.019",
    transform: "translate(2638.287 -163.955)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrotherliness);
export default __webpack_public_path__ + "static/media/brotherliness.915c68b1ab9853a424e5dc699c89957f.svg";
export { ForwardRef as ReactComponent };